import React from 'react'
import Contact from '../ContactPage/Contact/Contact'

function ContactPage() {
    
    return (
        <div>
            <Contact/>
        </div>
    )
}

export default ContactPage
